import { FC } from 'react';

import { Props, useTooltip } from '.';

export const Tooltip: FC<Props> = (props) => {
  const { Tooltip: TooltipComponent } = useTooltip(props);
  return TooltipComponent;
};
